import { useCallback } from 'react';

import { useDispatch } from 'react-redux';

import { actions as tasksActions } from '../../../../store/tasks';

const useClearTasks = () => {
  const dispatch = useDispatch();

  const clearTasks = useCallback(() => {
    dispatch(tasksActions.clear());
  }, [dispatch]);

  return clearTasks;
};

export default useClearTasks;
